{
  "accept": "Согласен",
  "activate account": "Активировать аккаунт",
  "added doctor to favorite doctror": "{name} зарегистрирован в качестве интересующего врача.",
  "addFiles": "Прикрепленный файл",
  "after payment is confirmed, completed.": "Заявка будет отправлена после подтверждения оплаты.",
  "agree": "Согласен",
  "agree to all terms and conditions": "Я принимаю все условия.",
  "agree to all terms and conditions.": "Я принимаю все условия.",
  "agreeAll": "Согласен на все условия",
  "Agreement": "Условия использования",
  "Agreement Content": "Условия использования",
  "allowingRecive": "Согласие на получение",
  "attach files": "Прикрепить файлов",
  "attached files": "Прикрепить файлов",
  "Attachments": "Вложения",
  "available email": "Доступные адреса электронной почты",
  "back": "Назад",
  "birthDate": "Дата рождения (2000/01/01)",
  "CalcelHeader": "Вы уверены, что хотите отменить?",
  "cancel": "Отменить",
  "Cancel": "Отменить",
  "cancel payment and reservation": "Отменить оплату и отмена",
  "cancel reservation": "Отменить бронирования",
  "canceled": "Отменить",
  "Canceled": "Отменить",
  "change": "Изменить",
  "change docor": "Изменить врача",
  "change password": "Изменить пароль",
  "changed password": "Ваш пароль был изменен.",
  "changePassword": "Изменить пароль",
  "check email": "Проверьте {email}.",
  "check email verificaion": "Проверьте дубликата адреса электронной почты.",
  "check payment": "Подтвердить оплату",
  "check prescription": "Проверьте рецепт",
  "check spam mail box": "Проверьте папку со спамом",
  "Check your email or password": "Проверьте свои регистрационные данные.",
  "CheckingItNow": "Идет проверка.",
  "chief complaint": "Основные симптомы",
  "chief complaint & files": "Прикрепить симптомы и файлов",
  "close": "Закрыть",
  "complete": "Готово",
  "complete to sign-up": "Нажмите кнопку, чтобы завершить регистрацию.",
  "Completed": "Отвечено",
  "confirm": "OK",
  "confirm cancel reservation": "После отмены вы не сможете вносить изменения. ^ Вы уверены, что хотите отменить это бронирование?",
  "confirm delete file": "Вы уверены, что хотите удалить этот файл?",
  "confirm new password": "Подтвердите новый пароль",
  "confirm reservation": "Подтверждение записи на прием",
  "confirm withdrawal": "Вы действительно хотите удалить свой аккаунт?",
  "confirm2": "Проверить содержание",
  "confirmed within one hour on average": "Подтверждается в среднем в течение часа",
  "confirmemail": "Проверить почту",
  "connected count to room": "Участвуют {count} человек",
  "Copied to clipboard": "Скопирована в буфер обмена.",
  "copy share link": "Копировать ссылку на приглашение",
  "DataType": "Тип файла",
  "date (from)": "Дата начала",
  "date (to)": "Дата начала",
  "dayNames": "Воскресенье, понедельник, вторник, среда, четверг, пятница, суббота",
  "dayNamesMin": "Вс, Пн, Вт, Ср, Чт, Пт, Сб",
  "dayNamesShort": "Вс, Пн, Вт, Ср, Чт, Пт, Сб",
  "DCS": "Служба удаленной совместной консультации",
  "default": "Базовое",
  "desired date": "Желаемая дата консультации",
  "desired date/time": "Желаемая дата и время",
  "desired date/time can be selected after doctor selected": "Желаемую дату и время можно выбрать и изменить после выбора врача",
  "desired time": "Желаемые часы приема",
  "did you not receive verification code via email": "Не получили номер подтверждения по электронной почте?",
  "didnt receive verification email": "Не получили электронное письмо подтверждения?",
  "direct input": "Прямой ввод",
  "Dispense": "Подготовлено",
  "do change": "Внести изменения",
  "do not show one week": "Не показывать в течение 7 дней",
  "do save": "Сохранить",
  "doctor": "Врач",
  "doctor name": "Имя врача",
  "doctor or dept": "Врач или отделение",
  "doctor response": "Ответ врача",
  "download": "Скачать",
  "Drag and drop files to here to upload.": "Перетащите вложение мышью или нажмите кнопку [Выбрать файл].",
  "drop files to here": "Перетащите файл",
  "edit": "Редактировать",
  "edit personal information": "Редактировать личную информацию",
  "edit requested data": "Редактировать бронирование совместной консультации",
  "email": "Электронная почта",
  "email already in use": "Эта электронная почта уже используется",
  "email confirmed": "Электронная почта подтверждено.",
  "EmailCheck": "Проверка дубликата",
  "EmailSendOK": "На указанный вами адрес электронной почты отправлено письмо.",
  "emptyMessage": "",
  "enter at least two characters without spaces": "Введите не менее 2 символов без пробелов.",
  "error": "Ошибка",
  "Error": "Ошибка",
  "error occured. please retry later": "Что-то пошло не так, повторите попытку позже.",
  "expire date": "Дата истечения срока действия",
  "Failed to copy to clipboard": "Не удалось скопировать в буфер обмена.",
  "failed to save": "Ошибка сохранения",
  "failed to sign up": "Регистрация не удалась",
  "familyName": "Фамилия",
  "favorite doctors": "Интересующий врач",
  "female": "Женщина",
  "fetch failed": "Не удается подключиться к службе.",
  "file-list": {
    "desc": {
      "a": "Изображения DICOM .после сжатие их в виде ZIP-файла",
      "b": "Если вы не можете просмотреть видео, записанное на вашем iPhone",
      "c": "нажмите",
      "d": "здесь",
      "e": "[Захват медиа]",
      "f": "См. раздел"
    }
  },
  "FileAttachments": "Прикрепить фото симптома",
  "FileCancel": "Отменить вложение",
  "FileChoose": "Выбрать файл",
  "FileManager": "Управление файлами",
  "FileTitle": "Имя файла",
  "FileType": "Расширение файла",
  "Fileupload": "Прикрепить файлов",
  "fill-form-data": "Пожалуйста, заполните необходимую информацию для регистрации.",
  "filtered by dept": "Поиск по отделам",
  "finding keywords (requested)": "Врачи, больницы, клиники и т. д.",
  "finished sign up": "будет завершено",
  "first name": "Имя",
  "firstName": "Имя",
  "fold": "Свернуть",
  "forgotPassword": "Забыли пароль",
  "ForOpinion": "Заявка на второе мнение",
  "from date": "Дата начала",
  "full name": "Имя и фамилия",
  "home": "Домашняя страница",
  "home-intro-1": "Иное лечение, чем когда-либо прежде,",
  "home-intro-2": "Специальная совместная консультация в онлайн",
  "how to take appointment for non-face-to-face cooperation": "Выберите специалиста, отправьте свои симптомы, и ваш запрос на совместную консультацию будет завершен.",
  "impossible to confirm": "Невозможно подтвердить",
  "InfoModify": "Редактировать информации профиля",
  "input chief complaint": "Введите основные симптомы",
  "input new password": "Введите новый пароль.",
  "input new password confirm": "Введите новый пароль еще раз.",
  "input old password": "Введите старый пароль.",
  "input your email address": "Введите адрес электронной почты, который вы использовали при регистрации",
  "input-email": "Введите адрес электронной почты.",
  "input-password": "Введите пароль.",
  "insertDateTime": "Дата подачи заявки",
  "invited-info": "Пожалуйста, введите имя участника и пароль приглашения, а затем нажмите на кнопку участвовать. Вы можете принять участие после того, как приглашающий создаст комнату.",
  "invited-title": "Пригласить в видеочат",
  "inviter": "Приглашающий",
  "join": "Зарегистрироваться",
  "join chat": "Присоединиться к чату",
  "korea standard time": "Корейское стандартное время",
  "last name": "Фамилия",
  "LastOrder": "Недавние платежи",
  "legal": "Политика конфиденциальности/Условия использования",
  "List of Doctors": "Выбор врача",
  "login failed": "Ошибка входа",
  "make sure the correct email address": "Убедитесь, что вы ввели правильный адрес электронной почты",
  "male": "Мужчина",
  "medically-vulnerable": "Уязвимые районы",
  "mofidy requested second opinion": "Редактировать запрос мнения",
  "monthNames": "Январь, февраль, март, апрель, май, июнь, июль, август, сентябрь, октябрь, ноябрь, декабрь",
  "monthNamesShort": "Январь, февраль, март, апрель, май, июнь, июль, август, сентябрь, октябрь, ноябрь, декабрь",
  "more": "Посмотреть больше",
  "my doctors": "Интересующий врач",
  "my page": "Мой аккаунт",
  "MyPage": "Мой аккаунт",
  "name": "Имя и фамилия",
  "new password": "Новый пароль",
  "newPassword": "Новый пароль",
  "newPasswordConfirm": "Подтвердить новый пароль",
  "newRequest": "Подать заявку",
  "newRequestOnlineCare": "Подать заявку на бронирование",
  "newRequestSecondOpinion": "Подать заявку на второе мнение",
  "next": "Следующий",
  "Next": "Следующий",
  "No": "Нет",
  "non-face-to-face cooperation": "Совместная консультация в онлайн",
  "not confirmed email": "Невозможно подтвердить электронную почту",
  "ok": "OK",
  "online-care-intro-1": "Лечение хронических заболеваний, таких как гипертония и диабет, и общих заболеваний, таких как простуда",
  "online-care-intro-2": "Совместная консультация в онлайн на дату бронирования",
  "OnlineCare": "Консультация в онлайн (рецепт)",
  "Page not found": "Страница не найдена",
  "paid history": "Детали оплаты",
  "paid list": "Детали оплаты",
  "paid then completed": "Заявка будет отправлена после оплаты.",
  "participant": "Участник",
  "password": "Пароль",
  "password changed": "Пароль был изменен.",
  "Password not correct": "Пароли не совпадают.",
  "password was changed or expired": "Пароль уже изменен или срок изменения истек.",
  "password-rules": "6 или более символов, число",
  "passwordConfirm": "Проверить пароль",
  "pay": "Оплата",
  "payment": "Оплата",
  "PayReady": "В ожидании оплаты",
  "pharmacy": "Аптека",
  "PharmacyNone": "Не выбрать",
  "Phone number": "Номер телефона",
  "phoneNumber": "Мобильный телефон ",
  "pi-agreement": "Согласие на передачу личной информации",
  "prescription": "Рецепт",
  "Prev": "Предыдущий",
  "previous": "Предыдущий",
  "privacy": "Политика конфиденциальности",
  "Privacy Policy": "Политика конфиденциальности",
  "Privacy Policy Content": "Политика конфиденциальности",
  "proceeding": "Выполняется",
  "profile": "Персональные данные",
  "quick": "Быстрый",
  "quick reservation description": "Подайте заявку на прием, выбрав предпочитаемого врача и предпочитаемую дату/время.",
  "ReceptionCompleted": "Заявка отправлена",
  "ReceptionSaveHeader": "Вы уверены, что хотите подать заявку?",
  "recommendted browsers": "Рекомендуемые браузеры",
  "refresh": "Обновить",
  "refund and reject": "Вернуть платеж и отклонить",
  "refunded": "Вернуть платеж",
  "Refused": "Отклонено",
  "registrationcompleted": "Завершить регистрацию",
  "reject": "Вывод средств",
  "rejected": "Отклонено",
  "remember me": "Оставаться в системе",
  "remove": "Удалить",
  "Remove": "Удалить",
  "request": "Запрос",
  "request appointment": "Подать заявку",
  "request comments": "Комментарии к бронированию",
  "request kind": "Категория",
  "request quick reservation": "Заявка на быстрый медицинский уход",
  "request reservation": "Прием заявок",
  "request second opinion": "Запрос вторичного заключения",
  "requested": "Подать заявку",
  "Requested": "Подать заявку на бронирование",
  "requested and wait payid": "Ожидание заявки и оплаты",
  "requested count": "Детали заявки",
  "requested detail information": "Детали заявки",
  "requested list": "Посмотреть сведения о заявке",
  "RequestedQuick": "Быстрое медицинский уход",
  "required": "Обязательно",
  "Required information is required": "Введите обязательную информацию.",
  "required phone number for servie": "Пожалуйста, введите номер своего мобильного телефона, чтобы воспользоваться услугой.",
  "resend verification email": "Отправить письмо для подтверждения еще раз",
  "reserved date/time": "Дата и время бронирования",
  "reset": "Отменить выбор",
  "reset password": "Сбросить пароль",
  "resetpassword": "Изменить пароль",
  "resetPasswordCompleted": "Пароль успешно изменен",
  "respond count": "Отвечено",
  "respond list": "История выполнения",
  "respondDateTime": "Дата ответа",
  "responded": "Готово",
  "response": "Ответить",
  "Result": "Результаты",
  "Return": "Вернуться",
  "room name": "Название комнаты",
  "room status": "Статус помещения",
  "save": "Сохранить",
  "save response": "Сохранить ответ",
  "Saved": "Сохранение завершено",
  "saved requesting reservation": "Ваша заявка отправлена.",
  "SavedFavorites": "Сохранен как семейный врач.",
  "SaveHeader": "Сохранить?",
  "Scheduled": "Бронирование подтверждено",
  "scheduled date/time": "Дата и время бронирования",
  "scheduledDatetime": "Дата и время бронирования",
  "search": "Поиск",
  "search failed": "Ошибка поиска",
  "second opinion": "Вторичное заключение",
  "second-opinion-intro-1": "На основе материалов обследований, таких как лечение рака и хирургические операции в других больницах.",
  "second-opinion-intro-2": "Если нужно заключение специалиста (требуется от 3 до 7 дней)",
  "SecondOpinion": "Вторичное заключение",
  "SecondOpinion2": "Вторичное заключение",
  "Select a Dept": "Выбор отдела",
  "select a hospital": "Выбор больницу",
  "Select a hospital": "Выбор больницу",
  "select a hospital to requesting": "Выберите, какую больницу вы хотели бы посетить.",
  "select desired date/time": "Выберите нужную дату и время",
  "select doctor": "Выбор врача",
  "select hopital and doctor": "Выбор больницы и врача",
  "sent confirming email": "Электронное письмо подтверждения отправлено.",
  "sent verification email": "Электронное письмо подтверждения отправлено.",
  "serious illness": "Тяжелые заболевания",
  "sex": "Пол",
  "sexF": "Женщина",
  "sexM": "Мужчина",
  "show detail": "Подробнее",
  "show detail profile": "Посмотреть детали профиля",
  "sign in": "Вход в систему",
  "Sign in": "Вход",
  "sign out": "Выйти",
  "sign up": "Зарегистрироваться",
  "sign-in-titl-1": "Вы можете получить совместную консультацию в онлайн, выбрав время приема,",
  "sign-in-titl-2": "Эта услуга дает вторичное заключение о серьезном заболевании.",
  "sign-up": "Регистрация пользователя",
  "signin": "Вход в систему",
  "Signout": "Выйти",
  "signup": "Регистрация пользователя",
  "signup-title": "Еще не зарегистрированы?",
  "signup-title-1": "Для управления пользователями мы собираем, используем и предоставляем личную информацию следующим образом.",
  "signup-title-2": "Пожалуйста, внимательно прочитайте содержание и подтвердите, согласны вы или нет.",
  "sms": "буква",
  "Status": "Статус",
  "submit": "Отправить",
  "submit application": "Подать заявку",
  "take appointment": "Забронировать совместную консультацию",
  "take appointment for non-face-to-face cooperation": "Подать заявку на совместную консультацию",
  "take average one week": "3-7 дней",
  "terms of use": "Условия использования",
  "there is no selectable doctors": "Нет доступных врачей на выбор.",
  "time standard": "Критерии",
  "title": "Заголовок",
  "to date": "Дата завершения",
  "toggle favarite doctor": "Вы можете отменить свой интерес, нажав еще раз.",
  "totalCallTime": "Время звонка",
  "Unable to load user": "Пользователь не найден.",
  "unfold": "Открыть",
  "update is completed": "Исправлено.",
  "User account locked out": "Попытка входа превышена, повторите попытку позже.",
  "User changed their password Failed": "Invalid Password",
  "User not found": "Пользователь не найден.",
  "userInfo": "Информация о пользователе",
  "userName": "Имя пользователя",
  "validateError": "Пожалуйста, заполните необходимые поля.",
  "Video": "Видео консультация",
  "video chat": "Консультация в онлайн",
  "view prescription": "Просмотр рецепта",
  "withdrawal": "Удалить аккаунт",
  "withdrawal info1": "Если вы удалите свой аккаунт, ваши медицинские записи будут",
  "withdrawal info2": "полностью удалены без возможности восстановления.",
  "WithdrawalHeader": "Удалить аккаунт.",
  "Yes": "Да",
  "Your email is not verified": "На адрес электронной почты, указанный вами при регистрации, было отправлено письмо.\n Откройте письмо и нажмите кнопку [Активировать учетную запись].\n Затем вы можете войти в систему."
}
